import Icon from '../components/Icon.vue'

Icon.register({"comment":{"width":1792,"height":1792,"paths":[{"d":"M1792 896q0 174-120 321.5t-326 233-450 85.5q-70 0-145-8-198 175-460 242-49 14-114 22-17 2-30.5-9t-17.5-29v-1q-3-4-0.5-12t2-10 4.5-9.5l6-9t7-8.5 8-9q7-8 31-34.5t34.5-38 31-39.5 32.5-51 27-59 26-76q-157-89-247.5-220t-90.5-281q0-130 71-248.5t191-204.5 286-136.5 348-50.5q244 0 450 85.5t326 233 120 321.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/comment.js
// module id = oSoA
// module chunks = 1